// @flow
import React from 'react';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import { formatFactCheckingResult } from '../../util/spell-check';
import { modalStyle } from '../media/modal-style';

type Props = {
	open: boolean,
	onRequestClose: () => void,
	content: string,
};

export default function ArticleFactCheckingDialog({ open, onRequestClose, content }: Props) {
	return (
		<Dialog
			open={open}
			modal={false}
			title="Результаты фактчекинга"
			contentStyle={{
				...modalStyle.main,
				width: 720,
				maxWidth: 'calc(100vw - 32px)',
			}}
			bodyStyle={{
				...modalStyle.body,
				borderTop: 'none',
				borderBottom: 'none',
				padding: '9px 31px 30px',
				fontSize: 14,
				lineHeight: 1.5,
				maxHeight: 'min(80vh, 640px)',
				overflowY: 'auto',
			}}
			titleStyle={{
				padding: '24px 24px 20px 30px',
				fontSize: 24,
			}}
			overlayStyle={modalStyle.overlay}
			onRequestClose={onRequestClose}
			autoScrollBodyContent
		>
			<div
				style={{
					position: 'absolute',
					right: 8,
					top: 9,
				}}
			>
				<IconButton onClick={onRequestClose}>
					<CloseIcon hoverColor="#542376" />
				</IconButton>
			</div>
			<div
				style={{
					overflowWrap: 'anywhere',
					wordBreak: 'break-word',
				}}
				dangerouslySetInnerHTML={{
					__html: formatFactCheckingResult(content),
				}}
			/>
		</Dialog>
	);
}



// WEBPACK FOOTER //
// src/components/articles/ArticleFactCheckingDialog.js